module.exports = __webpack_public_path__ + "281bec49d188c3b20d15a24c1ab34460.pdf";